import { NEWS } from "../../../mocks/newsData";

export default function Masthead() {
  const total = NEWS.length;
  const urgent = NEWS.filter((n) => n.urgent).length;
  const channels = new Set(NEWS.map((n) => n.channel)).size;

  return (
    <section className="relative overflow-hidden bg-background-100">
      <div className="absolute inset-y-0 left-0 w-1.5 bg-primary-500" aria-hidden="true" />
      <div className="mx-auto grid max-w-[1440px] grid-cols-1 gap-6 px-4 py-8 md:px-6 md:py-10 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <p className="flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.3em] text-primary-600">
            <i className="ri-flashlight-fill" aria-hidden="true" /> 编辑部 · 今日播报
          </p>
          <h1 className="mt-3 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            实时爆料
            <span className="ml-3 align-middle rounded-sm bg-primary-500 px-2 py-0.5 font-label text-sm font-bold uppercase tracking-wider text-background-50 md:text-base">
              Live
            </span>
          </h1>
          <p className="mt-3 font-heading text-lg font-bold text-foreground-800 md:text-2xl">
            今日热点滚动更新，全网资讯第一时间聚合与深度追踪
          </p>
          <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
            聚焦突发新闻与深度追踪，以分钟为单位跟进事件进展，用滚动时间线把“刚刚发生”讲到“尘埃落定”。满足你对实时爆料最新资讯的急切需求，不错过任何关键动态。
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-3">
            <a
              href="#focus"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-eye-line" aria-hidden="true" /> 去看今日焦点
            </a>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-foreground-950"
            >
              <i className="ri-send-plane-line" aria-hidden="true" /> 提供新闻线索
            </a>
          </div>
        </div>

        <div className="flex items-center lg:col-span-4">
          <dl className="grid w-full grid-cols-3 gap-3 lg:grid-cols-1">
            {[
              { label: "今日聚合动态", value: total },
              { label: "紧急快讯持续追踪", value: urgent },
              { label: "覆盖热点栏目", value: channels },
            ].map((item, index) => (
              <div
                key={item.label}
                className={
                  index === 0
                    ? "rounded-lg bg-primary-500 p-3 text-background-50"
                    : "rounded-lg border border-background-200 bg-background-50 p-3"
                }
              >
                <dt
                  className={
                    index === 0
                      ? "text-xs text-background-50/80"
                      : "text-xs text-foreground-500"
                  }
                >
                  {item.label}
                </dt>
                <dd
                  className={
                    index === 0
                      ? "mt-1 font-label text-2xl font-bold md:text-3xl"
                      : "mt-1 font-label text-2xl font-bold text-foreground-950 md:text-3xl"
                  }
                >
                  {item.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}